CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'
Label = require 'app/scripts/models/label'

class LabelList extends CollectionWithHelpers

  model: Label

module.exports = LabelList
